var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-view"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"slot-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }